// extracted by mini-css-extract-plugin
module.exports = {"showTopSeparator":"Partner_showTopSeparator_2Me6a","showSeparator":"Partner_showSeparator_gK3DM"};